import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import Subtitle from "../../subtitle";

interface LoginInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  errorMessage?: string;
  icon?: ReactNode;
  showPasswordToggle?: boolean;
  isPasswordVisible?: boolean;
  onTogglePassword?: () => void;
}

const LoginInput = forwardRef<HTMLInputElement, LoginInputProps>(
  ({ label, errorMessage, icon, showPasswordToggle, isPasswordVisible, onTogglePassword, type, ...props }, ref) => {

    const inputType =
      type === "password" && isPasswordVisible ? "text" : type;

    return (
      <div className="flex flex-col w-full gap-1">
        {label && (
          <Subtitle className="!text-[.85rem] !font-semibold !mb-1">
            {icon}
            {label}
          </Subtitle>
        )}

        <div className="relative">
          <input
            ref={ref}
            type={inputType}
            {...props}
            className={`
               w-full
               bg-[#ECF1F6]
               text-[#001120]
               text-[.85rem]
               px-[10px]
               py-[8px]
               rounded-[4px]
               border
               border-solid
               ${errorMessage ? "border-red-500" : "border-gray-300"}
               placeholder-gray-400
               outline-none
               font-light`}
          />
          {showPasswordToggle && type === "password" && (
            <button
              type="button"
              onClick={onTogglePassword}
              className="absolute right-0.5 top-[7.5px] border-none bg-transparent text-gray-400 hover:text-gray-600"
            >
              {isPasswordVisible ? (
                <IoEyeOutline size={18} />
              ) : (
                <IoEyeOffOutline size={18} />
              )}
            </button>
          )}
        </div>

        <div
          className={`text-[10px] text-red-500 transition-all duration-300 overflow-hidden ${errorMessage ? "max-h-[20px]" : "max-h-0"
            }`}
        >
          {errorMessage}
        </div>
      </div>
    );
  }
);

export default LoginInput;
